/* @flow */
import * as React from 'react';

import Text from 'components/Text.jsx';
import Time from 'components/Time.jsx';

import type { Props as TextProps } from 'components/Text.jsx';

type Props = {
  content: any,
  textProps: $Shape<TextProps>,
};

function TextCell({ content, textProps }: Props) {
  return <Text {...textProps}>{content}</Text>;
}

export function getTextCellGenerator(fieldName: string, textProps?: $Shape<TextProps>) {
  return (data: Object) => {
    return <TextCell content={data[fieldName]} textProps={textProps || {}} />;
  };
}

export function getTimestampCellGenerator(fieldName: string, textProps?: $Shape<TextProps>) {
  return (data: Object) => {
    const fieldValue = data[fieldName];
    let content;

    if (!fieldValue || isNaN(new Date(fieldValue))) {
      // invalid
      content = null;
    } else {
      content = <Time date={new Date(fieldValue)} month="short" day="numeric" year="numeric" />;
    }

    return <TextCell content={content} textProps={textProps || {}} />;
  };
}
